import { subjectIdFromName } from '@utils/helpers/SubjectParser';
import useHideBottomNavbar from '@utils/helpers/useHideBottomNavbar';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const WorksheetCompletedPDF = React.lazy(
  () => import('geniesmart/WorksheetCompletedPDF'),
);

const WorksheetCompletedPDFPage = () => {
  // fetch params
  const { subjectId, worksheetId } = useParams();

  useHideBottomNavbar();
  useEffect(() => {}, []);

  return (
    <WorksheetCompletedPDF
      subjectId={subjectIdFromName(subjectId)}
      worksheetId={worksheetId}
    ></WorksheetCompletedPDF>
  );
};

export default WorksheetCompletedPDFPage;
